<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid"/> Active Health Policies
      </CCardHeader>
      <PoliciesTable />
    </CCard> 
  </div>
</template>

<script>
import PoliciesTable from "@/components/HealthTable"
export default {
  components:{
    PoliciesTable
  }
}
</script>

<style>

</style>